module.exports = __webpack_public_path__ + "img/Crown@2x.5c6a6864.svg";